
export const featuresData = {
  'cte-mdfe': {
    slug: 'cte-mdfe',
    title: 'CT-e e MDF-e',
    subtitle: 'Emissão de Documentos Fiscais Eletrônicos',
    description: 'Emita CT-e e MDF-e de forma rápida, segura e em conformidade com a legislação. Reduza erros, evite multas e ganhe agilidade na sua operação.',
    icon: 'ri-file-text-line',
    heroImage: 'https://public.readdy.ai/ai/img_res/edbfebfd1e74c2a72a3558b44b12838d.jpg',
    benefits: [
      {
        icon: 'ri-speed-line',
        title: 'Emissão Rápida',
        description: 'Emita documentos em segundos com preenchimento automático de dados',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Conformidade Fiscal',
        description: 'Sempre atualizado com as últimas exigências da SEFAZ',
      },
      {
        icon: 'ri-error-warning-line',
        title: 'Redução de Erros',
        description: 'Validação automática evita rejeições e retrabalho',
      },
      {
        icon: 'ri-money-dollar-circle-line',
        title: 'Evite Multas',
        description: 'Documentação correta e dentro dos prazos legais',
      },
    ],
    features: [
      'Emissão de CT-e (Conhecimento de Transporte Eletrônico)',
      'Emissão de MDF-e (Manifesto Eletrônico de Documentos Fiscais)',
      'Cancelamento e carta de correção',
      'Consulta de status na SEFAZ em tempo real',
      'Importação de XML de NF-e',
      'Cálculo automático de impostos (ICMS, PIS, COFINS)',
      'Geração de DACTE e DAMDFE',
      'Envio automático por email para clientes',
      'Histórico completo de documentos emitidos',
      'Relatórios de emissão por período',
    ],
    screenshots: [
      {
        image: 'https://readdy.ai/api/search-image?query=clean-modern-software-dashboard-showing-electronic-invoice-emission-form-with-input-fields-and-buttons-professional-interface-design-white-background-teal-accents-minimalist-ui&width=1200&height=700&seq=feat-cte-2&orientation=landscape',
        caption: 'Tela de emissão de CT-e com preenchimento inteligente',
      },
      {
        image: 'https://readdy.ai/api/search-image?query=software-interface-showing-list-of-electronic-documents-with-status-indicators-and-filters-modern-table-design-clean-professional-look-white-and-teal-color-scheme&width=1200&height=700&seq=feat-cte-3&orientation=landscape',
        caption: 'Listagem de documentos com status em tempo real',
      },
    ],
    stats: [
      { value: '99.9%', label: 'Taxa de aprovação' },
      { value: '-70%', label: 'Tempo de emissão' },
      { value: '0', label: 'Multas fiscais' },
    ],
    faq: [
      {
        question: 'O sistema está sempre atualizado com a legislação?',
        answer: 'Sim! Nossa equipe monitora constantemente as atualizações da SEFAZ e implementa as mudanças automaticamente, sem custo adicional.',
      },
      {
        question: 'Posso importar dados de outros sistemas?',
        answer: 'Sim, o TG WEB permite importar XML de NF-e e dados de outros sistemas para facilitar a migração.',
      },
      {
        question: 'Como funciona o suporte em caso de rejeição?',
        answer: 'O sistema identifica automaticamente o motivo da rejeição e sugere a correção. Nossa equipe de suporte também está disponível para ajudar.',
      },
    ],
  },
  'financeiro': {
    slug: 'financeiro',
    title: 'Controle Financeiro',
    subtitle: 'Gestão Completa de Finanças',
    description: 'Tenha controle total sobre custos, despesas e fluxo de caixa da sua transportadora. Tome decisões estratégicas baseadas em dados reais.',
    icon: 'ri-money-dollar-circle-line',
    heroImage: 'https://readdy.ai/api/search-image?query=modern-financial-dashboard-showing-charts-graphs-and-cash-flow-analytics-on-computer-screen-professional-business-environment-clean-design-teal-and-orange-data-visualization&width=800&height=600&seq=feat-fin-1&orientation=landscape',
    benefits: [
      {
        icon: 'ri-pie-chart-line',
        title: 'Visão Completa',
        description: 'Dashboard com todos os indicadores financeiros em tempo real',
      },
      {
        icon: 'ri-truck-line',
        title: 'Custo por Veículo',
        description: 'Saiba exatamente quanto cada veículo custa e gera de receita',
      },
      {
        icon: 'ri-calendar-check-line',
        title: 'Fluxo de Caixa',
        description: 'Previsão de entradas e saídas para melhor planejamento',
      },
      {
        icon: 'ri-funds-line',
        title: 'Rentabilidade',
        description: 'Identifique operações lucrativas e otimize resultados',
      },
    ],
    features: [
      'Contas a pagar e receber',
      'Fluxo de caixa projetado',
      'Controle de custos por veículo',
      'Centro de custos personalizável',
      'Conciliação bancária',
      'Gestão de orçamentos',
      'Relatórios de DRE',
      'Controle de comissões',
      'Integração com bancos',
      'Alertas de vencimentos',
    ],
    screenshots: [
      {
        image: 'https://readdy.ai/api/search-image?query=financial-software-dashboard-with-revenue-charts-expense-tracking-and-cash-flow-graphs-modern-clean-interface-white-background-professional-business-analytics-display&width=1200&height=700&seq=feat-fin-2&orientation=landscape',
        caption: 'Dashboard financeiro com indicadores em tempo real',
      },
      {
        image: 'https://readdy.ai/api/search-image?query=accounts-payable-receivable-management-interface-showing-payment-schedule-and-due-dates-clean-modern-software-design-organized-table-layout-professional-look&width=1200&height=700&seq=feat-fin-3&orientation=landscape',
        caption: 'Gestão de contas a pagar e receber',
      },
    ],
    stats: [
      { value: '+25%', label: 'Redução de custos' },
      { value: '100%', label: 'Visibilidade financeira' },
      { value: '-80%', label: 'Tempo em planilhas' },
    ],
    faq: [
      {
        question: 'Posso controlar custos por veículo individualmente?',
        answer: 'Sim! O sistema permite vincular todas as despesas a veículos específicos, gerando relatórios detalhados de custo por km rodado.',
      },
      {
        question: 'O sistema integra com meu banco?',
        answer: 'Sim, oferecemos integração com os principais bancos para importação de extratos e conciliação automática.',
      },
      {
        question: 'Como funciona o fluxo de caixa projetado?',
        answer: 'O sistema analisa suas contas a pagar e receber para projetar o saldo futuro, ajudando no planejamento financeiro.',
      },
    ],
  },
  'estoque': {
    slug: 'estoque',
    title: 'Gestão de Estoque',
    subtitle: 'Controle de Peças e Insumos',
    description: 'Controle total de peças, pneus, combustível e insumos. Evite perdas, reduza custos de manutenção e mantenha sua frota sempre operacional.',
    icon: 'ri-archive-line',
    heroImage: 'https://readdy.ai/api/search-image?query=modern-warehouse-inventory-management-system-showing-organized-shelves-with-auto-parts-and-supplies-clean-industrial-environment-digital-tracking-system-display-professional-logistics&width=800&height=600&seq=feat-est-1&orientation=landscape',
    benefits: [
      {
        icon: 'ri-stack-line',
        title: 'Controle Total',
        description: 'Saiba exatamente o que tem em estoque e onde está',
      },
      {
        icon: 'ri-alarm-warning-line',
        title: 'Alertas de Mínimo',
        description: 'Receba avisos quando itens atingirem estoque mínimo',
      },
      {
        icon: 'ri-exchange-line',
        title: 'Rastreabilidade',
        description: 'Histórico completo de movimentações e uso',
      },
      {
        icon: 'ri-price-tag-3-line',
        title: 'Custo Médio',
        description: 'Cálculo automático de custo médio de aquisição',
      },
    ],
    features: [
      'Cadastro de produtos e categorias',
      'Controle de entradas e saídas',
      'Gestão de múltiplos almoxarifados',
      'Estoque mínimo e máximo',
      'Inventário e ajustes',
      'Requisição de materiais',
      'Vínculo com ordens de serviço',
      'Controle de pneus e recapagens',
      'Gestão de combustível',
      'Relatórios de consumo',
    ],
    screenshots: [
      {
        image: 'https://readdy.ai/api/search-image?query=inventory-management-software-interface-showing-product-list-with-stock-levels-and-categories-clean-modern-design-organized-data-table-professional-warehouse-system&width=1200&height=700&seq=feat-est-2&orientation=landscape',
        caption: 'Controle de estoque com níveis e alertas',
      },
      {
        image: 'https://readdy.ai/api/search-image?query=stock-movement-history-interface-showing-entries-exits-and-transfers-modern-software-design-clean-table-layout-tracking-system-professional-look&width=1200&height=700&seq=feat-est-3&orientation=landscape',
        caption: 'Histórico de movimentações detalhado',
      },
    ],
    stats: [
      { value: '-40%', label: 'Perdas de estoque' },
      { value: '+30%', label: 'Economia em compras' },
      { value: '100%', label: 'Rastreabilidade' },
    ],
    faq: [
      {
        question: 'Posso controlar estoque em diferentes locais?',
        answer: 'Sim! O sistema permite gerenciar múltiplos almoxarifados e fazer transferências entre eles.',
      },
      {
        question: 'Como funciona o controle de pneus?',
        answer: 'Cada pneu é cadastrado individualmente com histórico de uso, recapagens e quilometragem, permitindo análise de vida útil.',
      },
      {
        question: 'O sistema calcula custo médio automaticamente?',
        answer: 'Sim, a cada entrada o sistema recalcula o custo médio ponderado de cada item.',
      },
    ],
  },
  'motorista': {
    slug: 'motorista',
    title: 'Cadastro de Motoristas',
    subtitle: 'Gestão Completa de Condutores',
    description: 'Gerencie toda a documentação, histórico e desempenho dos seus motoristas. Mantenha a conformidade e otimize a alocação da equipe.',
    icon: 'ri-user-star-line',
    heroImage: 'https://readdy.ai/api/search-image?query=professional-truck-driver-management-system-interface-showing-driver-profiles-and-documentation-modern-fleet-management-software-clean-design-professional-transportation-company&width=800&height=600&seq=feat-mot-1&orientation=landscape',
    benefits: [
      {
        icon: 'ri-id-card-line',
        title: 'Documentação Completa',
        description: 'Todos os documentos do motorista em um só lugar',
      },
      {
        icon: 'ri-calendar-event-line',
        title: 'Alertas de Vencimento',
        description: 'Nunca perca o vencimento de CNH ou exames',
      },
      {
        icon: 'ri-history-line',
        title: 'Histórico Operacional',
        description: 'Registro completo de viagens e ocorrências',
      },
      {
        icon: 'ri-star-line',
        title: 'Avaliação de Desempenho',
        description: 'Métricas para identificar os melhores motoristas',
      },
    ],
    features: [
      'Cadastro completo com foto e documentos',
      'Controle de CNH e categorias',
      'Alertas de vencimento de documentos',
      'Histórico de viagens realizadas',
      'Controle de exames médicos',
      'Registro de infrações e multas',
      'Vínculo com veículos',
      'Controle de adiantamentos',
      'Gestão de comissões',
      'Relatórios de produtividade',
    ],
    screenshots: [
      {
        image: 'https://readdy.ai/api/search-image?query=driver-profile-management-interface-showing-personal-information-documents-and-license-details-modern-clean-software-design-professional-fleet-management-system&width=1200&height=700&seq=feat-mot-2&orientation=landscape',
        caption: 'Perfil completo do motorista com documentação',
      },
      {
        image: 'https://readdy.ai/api/search-image?query=driver-trip-history-and-performance-dashboard-showing-completed-routes-and-metrics-modern-interface-design-clean-data-visualization-professional-look&width=1200&height=700&seq=feat-mot-3&orientation=landscape',
        caption: 'Histórico de viagens e desempenho',
      },
    ],
    stats: [
      { value: '0', label: 'Documentos vencidos' },
      { value: '+20%', label: 'Produtividade' },
      { value: '100%', label: 'Conformidade' },
    ],
    faq: [
      {
        question: 'Como funcionam os alertas de vencimento?',
        answer: 'O sistema envia notificações automáticas com antecedência configurável para CNH, exames médicos e outros documentos.',
      },
      {
        question: 'Posso vincular motoristas a veículos específicos?',
        answer: 'Sim, você pode definir motoristas titulares para cada veículo e controlar a alocação da equipe.',
      },
      {
        question: 'O sistema controla comissões?',
        answer: 'Sim, você pode configurar regras de comissão por viagem, frete ou quilometragem e gerar relatórios de pagamento.',
      },
    ],
  },
  'relatorios': {
    slug: 'relatorios',
    title: 'Relatórios Gerenciais',
    subtitle: 'Inteligência para Decisões',
    description: 'Dashboards e relatórios estratégicos para acompanhar a performance da sua transportadora e tomar decisões baseadas em dados.',
    icon: 'ri-bar-chart-box-line',
    heroImage: 'https://readdy.ai/api/search-image?query=business-intelligence-dashboard-with-charts-graphs-and-kpi-metrics-modern-analytics-interface-professional-data-visualization-clean-design-teal-and-orange-accents&width=800&height=600&seq=feat-rel-1&orientation=landscape',
    benefits: [
      {
        icon: 'ri-dashboard-line',
        title: 'Dashboards Visuais',
        description: 'Gráficos e indicadores fáceis de entender',
      },
      {
        icon: 'ri-time-line',
        title: 'Tempo Real',
        description: 'Dados atualizados automaticamente',
      },
      {
        icon: 'ri-download-line',
        title: 'Exportação Fácil',
        description: 'Exporte para Excel, PDF ou compartilhe online',
      },
      {
        icon: 'ri-filter-line',
        title: 'Filtros Avançados',
        description: 'Analise dados por período, veículo, motorista e mais',
      },
    ],
    features: [
      'Dashboard executivo',
      'Rentabilidade por veículo',
      'Custo por quilômetro',
      'Análise de faturamento',
      'Relatório de despesas',
      'Performance de motoristas',
      'Indicadores de manutenção',
      'Comparativo mensal',
      'Exportação em múltiplos formatos',
      'Agendamento de relatórios',
    ],
    screenshots: [
      {
        image: 'https://readdy.ai/api/search-image?query=executive-dashboard-showing-fleet-performance-metrics-revenue-charts-and-cost-analysis-modern-business-intelligence-interface-clean-professional-design&width=1200&height=700&seq=feat-rel-2&orientation=landscape',
        caption: 'Dashboard executivo com KPIs principais',
      },
      {
        image: 'https://readdy.ai/api/search-image?query=detailed-analytics-report-showing-vehicle-profitability-and-cost-breakdown-charts-modern-software-interface-clean-data-tables-professional-look&width=1200&height=700&seq=feat-rel-3&orientation=landscape',
        caption: 'Análise detalhada de rentabilidade',
      },
    ],
    stats: [
      { value: '+50', label: 'Relatórios disponíveis' },
      { value: '5min', label: 'Para gerar análises' },
      { value: '360°', label: 'Visão do negócio' },
    ],
    faq: [
      {
        question: 'Posso criar relatórios personalizados?',
        answer: 'Sim! Além dos relatórios padrão, você pode criar análises customizadas com os filtros e métricas que precisar.',
      },
      {
        question: 'Os relatórios são atualizados em tempo real?',
        answer: 'Sim, os dashboards e relatórios refletem os dados mais recentes do sistema automaticamente.',
      },
      {
        question: 'Posso agendar envio de relatórios?',
        answer: 'Sim, você pode configurar o envio automático de relatórios por email em frequência diária, semanal ou mensal.',
      },
    ],
  },
  'nuvem': {
    slug: 'nuvem',
    title: '100% na Nuvem',
    subtitle: 'Acesso de Qualquer Lugar',
    description: 'Sistema totalmente online, sem instalação. Acesse de qualquer dispositivo, a qualquer momento, com total segurança e backups automáticos.',
    icon: 'ri-cloud-line',
    heroImage: 'https://readdy.ai/api/search-image?query=cloud-computing-concept-showing-connected-devices-laptop-tablet-smartphone-accessing-cloud-services-modern-technology-illustration-clean-professional-design-teal-accents&width=800&height=600&seq=feat-nuv-1&orientation=landscape',
    benefits: [
      {
        icon: 'ri-device-line',
        title: 'Multi-dispositivo',
        description: 'Acesse do computador, tablet ou celular',
      },
      {
        icon: 'ri-shield-keyhole-line',
        title: 'Segurança Total',
        description: 'Criptografia e proteção de dados avançada',
      },
      {
        icon: 'ri-refresh-line',
        title: 'Backup Automático',
        description: 'Seus dados sempre protegidos e recuperáveis',
      },
      {
        icon: 'ri-rocket-line',
        title: 'Sempre Atualizado',
        description: 'Novas funcionalidades sem custo adicional',
      },
    ],
    features: [
      'Acesso via navegador web',
      'Aplicativo mobile responsivo',
      'Criptografia SSL/TLS',
      'Backup diário automático',
      'Servidores redundantes',
      'Uptime de 99.9%',
      'Atualizações automáticas',
      'Suporte técnico incluso',
      'Sem necessidade de instalação',
      'Escalabilidade ilimitada',
    ],
    screenshots: [
      {
        image: 'https://readdy.ai/api/search-image?query=responsive-web-application-displayed-on-multiple-devices-desktop-laptop-tablet-mobile-showing-same-interface-modern-clean-design-professional-software&width=1200&height=700&seq=feat-nuv-2&orientation=landscape',
        caption: 'Acesso em qualquer dispositivo',
      },
      {
        image: 'https://readdy.ai/api/search-image?query=cloud-security-dashboard-showing-encryption-status-backup-logs-and-system-health-modern-interface-design-professional-it-management-clean-look&width=1200&height=700&seq=feat-nuv-3&orientation=landscape',
        caption: 'Painel de segurança e backups',
      },
    ],
    stats: [
      { value: '99.9%', label: 'Disponibilidade' },
      { value: '256-bit', label: 'Criptografia' },
      { value: '24/7', label: 'Monitoramento' },
    ],
    faq: [
      {
        question: 'Preciso instalar algum programa?',
        answer: 'Não! O TG WEB funciona 100% no navegador. Basta acessar o site e fazer login.',
      },
      {
        question: 'Meus dados estão seguros?',
        answer: 'Sim! Utilizamos criptografia de ponta, servidores em data centers certificados e backups diários automáticos.',
      },
      {
        question: 'O que acontece se a internet cair?',
        answer: 'O sistema possui recursos offline para operações críticas. Quando a conexão voltar, os dados são sincronizados automaticamente.',
      },
    ],
  },
};

export const relatedFeatures = {
  'cte-mdfe': ['financeiro', 'relatorios', 'nuvem'],
  'financeiro': ['cte-mdfe', 'estoque', 'relatorios'],
  'estoque': ['financeiro', 'motorista', 'relatorios'],
  'motorista': ['estoque', 'relatorios', 'nuvem'],
  'relatorios': ['financeiro', 'cte-mdfe', 'nuvem'],
  'nuvem': ['cte-mdfe', 'financeiro', 'relatorios'],
};
